<template>
  <div class="page-container">
    <div class="pay-trans-details">
      <div class="filter-section-container">
        <div class="filter-fixed">
          <span class="filter-fixed-title">{{ $t('data.filter_section') }}</span>
          <i
            class="el-icon-arrow-down filter-fixed-arrow"
            :class="{'fiter-icon-arrow-route':!showFilterContent}"
            @click="onClickFixedArrow"
          />
        </div>
        <el-collapse-transition>
          <div v-show="showFilterContent">
            <div id="filter-content" class="filter-content">
              <div class="filter-item">
                <div class="filter-item-label">{{ $t('merchantAccount.create_time') }}</div>
                <el-date-picker
                  v-model="search.times"
                  class="filter-item-value"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00','23:59:59']"
                  type="daterange"
                  range-separator="~"
                  :start-placeholder="$t('components.start_date')"
                  :end-placeholder="$t('components.end_date')"
                />
              </div>
              <div class="filter-item">
                <div class="filter-item-label">
                  {{ $t('merchantAccount.complete_time') }}
                </div>

                <el-date-picker
                  v-model="search.response_times"
                  class="filter-item-value"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00','23:59:59']"
                  type="daterange"
                  range-separator="~"
                  :start-placeholder="$t('components.start_date')"
                  :end-placeholder="$t('components.end_date')"
                  :picker-options="$commonFn.dateLimit(this, 31)"
                />
              </div>

              <div class="filter-item">
                <div class="filter-item-label">
                  {{ $t('data.actual_settlement_time') }}
                </div>
                <el-date-picker
                  v-model="search.settlement_time"
                  class="filter-item-value"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="daterange"
                  range-separator="~"
                  :start-placeholder="$t('components.start_date')"
                  :end-placeholder="$t('components.end_date')"
                  :default-time="['00:00:00', '23:59:59']"
                />
              </div>

              <div class="filter-item">
                <div class="filter-item-label">{{ $t('customerService.payment_type') }}</div>
                <el-select v-model="search.product_category" class="filter-item-value" size="small" clearable>
                  <el-option
                    v-for="(item,index) in productCategoryMap"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>

              <div class="filter-item">
                <div class="filter-item-label">{{ $t('merchant.payment_channel') }}</div>
                <el-select v-model="search.channel_code" filterable class="filter-item-value" size="small" clearable>
                  <el-option
                    v-for="(item,index) in compFilterPaymentChannel"
                    :key="index"
                    :label="item.channel_code"
                    :value="item.channel_code"
                  />
                </el-select>
              </div>
              <div class="filter-item">
                <div class="filter-item-label">{{ $t('merchantAccount.transaction_status') }}</div>
                <el-select v-model="search.transaction_status" class="filter-item-value" size="small" clearable>
                  <el-option
                    v-for="(item,index) in payTransactionStatusArr"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>

              <div class="filter-item">
                <div class="filter-item-label">{{ $t('customerService.transaction_id') }}</div>
                <el-input v-model="search.transaction_id" size="small" type="text" class="filter-item-value" clearable />
              </div>

              <div class="filter-item">
                <div class="filter-item-label">{{ $t('customerService.merchant_order_id') }}</div>
                <el-input v-model="search.merchant_order_id" size="small" type="text" class="filter-item-value" clearable />
              </div>

              <div class="filter-item">
                <div class="filter-item-label">{{ $t('customerService.payment_code') }}</div>
                <el-input v-model="search.payment_code" size="small" type="text" class="filter-item-value" clearable />
              </div>
            </div>
            <div class="filter-operate">
              <div class="filter-operate-left">
                <el-button class="mb-10 download-btn" :loading="downloading" type="info" size="small" icon="el-icon-download" @click="onClickDowmloadBtn">{{ $t('components.download') }}</el-button>
              </div>
              <div class="filter-operate-right">
                <el-button class="search-btn mb-10" size="small" @click="onClickReset">{{ $t('components.clear') }}</el-button>
                <el-button class="search-btn mb-10" type="primary" size="small" icon="el-icon-search" @click="handleFilter()">{{ $t('components.search') }}</el-button>
              </div>

            </div>
          </div>

        </el-collapse-transition>
      </div>
      <div class="total-container">
        <div class="total-item">{{ $t('data.total_count') }}: <span style="color:#3855F1;">{{ total_count }}</span>
        </div>
        <div class="total-item">{{ $t('data.total_amount') }}: <span style="color:#3855F1;">{{ $store.getters.currency }}  {{ total_amount | toDivideWithDot }}</span>
        </div>
        <div class="total-item">{{ $t('data.total_fee') }}: <span style="color:#3855F1;">{{ $store.getters.currency }}  {{ total_fee | toDivideWithDot }}</span>
        </div>

      </div>
      <div class="tableContainer">
        <!-- 列表 -->
        <el-table
          v-loading="listLoading"
          :data="tableData"
          stripe
          fit
          highlight-current-row
          style="width: 100%"
        >

          <el-table-column :label="$t('customerService.transaction_id')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.transaction_id }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('merchantAccount.merchant_order_id')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.merchant_order_id }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('customerService.payment_type')" align="center">
            <template slot-scope="scope">
              <span>{{ getproductCategoryMap( scope.row.product_category) }}</span>
            </template>
          </el-table-column>

          <el-table-column min-width="110" :label="$t('merchant.payment_channel')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.channel_code }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('merchantAccount.transaction_status')" align="center">
            <template slot-scope="scope">
              <el-tag class="tag-custom" :type="getPayTransStatusType(scope.row.transaction_status)">{{ getPayTransStatusLabel(scope.row.transaction_status) }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column :label="$t('merchantAccount.transaction_amount')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.transaction_amount | toDivideWithDot }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('merchant.service_fee')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.fee_split | toDivideWithDot }}</span>
            </template>
          </el-table-column>

          <el-table-column width="105" :label="$t('merchantAccount.create_time')" align="center">
            <template slot-scope="scope">
              {{ scope.row.transaction_create_time }}
            </template>
          </el-table-column>

          <el-table-column width="105" :label="$t('merchantAccount.complete_time')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.transaction_return_time }}</span>
            </template>
          </el-table-column>

          <el-table-column v-if="$store.getters.isID && compIsJTMerchant" :label="$t('merchant.jt_institute_way_code')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.institute_way_code }}</span>
            </template>
          </el-table-column>

          <el-table-column min-width="110" :label="$t('data.remark')" align="center">
            <template slot-scope="scope">
              <span v-if="!scope.row.remark || scope.row.remark.length<=10">{{ scope.row.remark }}</span>
              <el-tooltip v-else class="item" effect="light" :content="scope.row.remark" placement="top">
                <span class="show-ellipsis" style="cursor: pointer;display:inline-block;max-width: 100px;">{{ scope.row.remark }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <!--操作-->
          <el-table-column :label="$t('components.operation')" align="center" min-width="100">
            <template slot-scope="scope">
              <el-tooltip placement="top">
                <div slot="content">
                  <span> {{ $t('components.detail') }}</span> <br>
                </div>
                <svg-icon class-name="icon-function" icon-class="operation-detail" @click="onClickDetailTxt(scope.row)" />
              </el-tooltip>
              <!-- <el-tooltip v-if="store.getters.authorities.includes('AUTH_CODE_PAYMENT_REFUND')" placement="top">
                <div slot="content">
                  <span v-if="[1,4,5,6,8,9].includes(scope.row.refund_not_support_reason)"> {{ $t('tips.refund_tip_1') }} <br> </span>
                  <span v-else-if="[2,3].includes(scope.row.refund_not_support_reason)"> {{ $t('tips.refund_tip_2') }}<br> </span>
                  <span v-else-if="[7].includes(scope.row.refund_not_support_reason)"> {{ $t('tips.refund_tip_3') }}<br> </span>
                  <span v-else> {{ $t('components.refund') }}<br> </span>
                </div>
                <svg-icon :class="{ 'is-disabled': !(scope.row.original_refund_status && scope.row.original_refund_status !== 1) }" class-name="icon-function" icon-class="refund-icon" @click="onClickRefundTxt(scope.row)" />
              </el-tooltip> -->
            </template>
          </el-table-column>

        </el-table>

        <div class="pagination-container">
          <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
        </div>
      </div>
      <payment-details-modal ref="paymentDetailsModal" :detail-id="detailId" :auth-merchant-no="$route.params.merchant_no" />
      <!-- <payment-refund-modal ref="paymentRefundModal" :detail-id="detailId" @updatelist="handleFilter" /> -->
    </div>
  </div>
</template>

<script>
import { getPaymentList, PostPartnerMerchantDownloadPaymentFile } from '@/api/service-provider-tools/service-provider-tools'
import { fetchPageMethodChannelList } from '@/api/components/components'

import {
  payTransactionStatusMap,
  payTransactionStatusVoidMap,
  payTransactionTypeMap,
  productCategoryMap
} from '@/utils/maps'
import { transactionSettlementStatusMap } from '@/maps/status.js'
import { filterEmptyAttr, exportXlsx } from '@/utils/common'
import { appointDate } from '@/utils/index.js'
import store from '@/store'

export default {
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    PaymentDetailsModal: () => import('@/views/paycools/data/components/Modal/PayinDetailsModal.vue'),
    // PaymentRefundModal: () => import('./Modal/PayinRefundModal')
  },
  data() {
    this.jtInstituteWayCode = [
      {
        label: 'BCA',
        value: 'BCA'
      },
      {
        label: 'BNI',
        value: 'BNI'
      },
      {
        label: 'OTHERS',
        value: 'OTHERS'
      }
    ]
    this.TRANSACTION_STATUS = {
      void: 4
    }
    return {
      showFilterContent: true,
      search: {
        merchant_order_id: '',
        transaction_status: null, // 交易状态
        times: [appointDate(-3) + ' 00:00:00', appointDate() + ' 23:59:59'],
        response_times: [],
        settlement_time: [],
        channel_code: '',
        payment_code: '',
        transaction_id: '',
        payer_mobile: '',
        app_name: '',
        checkout_id: ''
      },
      paymentMethodArr: [
        { label: 'Bill Payment', value: 2 },
        { label: 'QR Code', value: 1 },
        { label: 'Bank Transfer', value: 3 }
      ],
      payinChannelList: [],
      tableData: [],
      total_amount: 0,
      total_fee: 0,
      total_count: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      detailId: '',
      downloading: false
    }
  },
  computed: {
    store() {
      return store
    },
    payTransactionStatusArr() {
      // 目前只有泰国有撤销
      const payTransactionStatusArr = payTransactionStatusMap()
      const queryPayTransactionStatusVoidArr = payTransactionStatusVoidMap()
      return this.$store.getters.curCountry.country_code === 'TH' ? queryPayTransactionStatusVoidArr : payTransactionStatusArr
    },
    compFilterPaymentChannel() {
      if (!this.search.pay_product_type) {
        return this.payinChannelList
      }
      const arr = this.payinChannelList.filter(item => item.payment_method === this.search.pay_product_type)
      return arr
    },
    getPayTransStatusType() {
      return function(value) {
        return payTransactionStatusVoidMap(value).type
      }
    },
    getPayTransStatusLabel() {
      return function(value) {
        return payTransactionStatusVoidMap(value).label
      }
    },
    getPayTransTypeMap() {
      return function(val) {
        return payTransactionTypeMap(val).label
      }
    },
    getPayTransTypeStyle() {
      return function(val) {
        return payTransactionTypeMap(val).type
      }
    },
    productCategoryMap() {
      return productCategoryMap()
    },
    getproductCategoryMap() {
      return function(value) {
        return productCategoryMap(value).label
      }
    },
    transactionSettlementStatusMap() {
      return transactionSettlementStatusMap()
    },
    compIsJTMerchant() {
      return this.$store.state.user.isJtMerchant
    }
  },
  created() {
    const { checkout_id } = this.$route.query
    this.search.checkout_id = checkout_id
    this.getAllChannelList()
    this.handleFilter()
  },
  methods: {
    getAllChannelList() {
      fetchPageMethodChannelList({
        auth_merchant_no: this.$route.params.merchant_no
      }).then(res => {
        this.payinChannelList = res.data || []
      })
    },
    getPaymentDetailInfo(params) {
      this.listLoading = true
      getPaymentList(params).then(res => {
        // eslint-disable-next-line no-unused-vars
        const { total = 15, list = [], current = 1, total_amount, total_fee } = res.data || {}
        this.listQuery.total = total
        this.listQuery.page = params.page ? params.page : 1
        this.tableData = list
        this.total_amount = total_amount
        this.total_fee = total_fee
        this.total_count = total
      }).finally(() => {
        this.listLoading = false
      })
    },
    getParams(otherParams = {}) {
      const { transaction_status, channel_code, times = [], response_times = [], settlement_time = [], merchant_order_id, transaction_id, payment_code, payer_mobile, app_name, ...otherSearch } = this.search
      let params = {
        start_date_time: times && times[0],
        end_date_time: times && times[1],
        response_start_date_time: response_times && response_times[0],
        response_end_date_time: response_times && response_times[1],
        settlement_time_start: settlement_time && settlement_time[0],
        settlement_time_end: settlement_time && settlement_time[1],
        transaction_status,
        channel_code,
        mch_order_id: merchant_order_id,
        transaction_id,
        payment_code,
        payer_mobile,
        app_name,
        ...otherSearch,
        ...otherParams,
        auth_merchant_no: this.$route.params.merchant_no
      }
      if (payer_mobile && ((!times || times.length === 0) && (!response_times || response_times.length === 0))) {
        this.$message.warning('Pls input Transition Date')
        return null
      }
      params = filterEmptyAttr(params)
      return params
    },

    showPayDetailModal() {
      this.$refs.paymentDetailsModal.changModalStatus(true)
    },

    handleFilter(otherParams = {}) {
      if (!this.$commonFn.checkSubmitDateLimit(this.search.times, 15)) {
        this.$message.warning('The maximum date range  is limited to 15 days, please select again')
        return
      }
      if (!this.$commonFn.checkSubmitDateLimit(this.search.response_times, 15)) {
        this.$message.warning('The maximum date range  is limited to 15 days, please select again')
        return
      }
      if (!this.$commonFn.checkSubmitDateLimit(this.search.settlement_time, 31)) {
        this.$message.warning('The maximum date range  is limited to 31 days, please select again')
        return
      }
      const params = this.getParams(otherParams)
      if (!params) {
        return
      }
      this.getPaymentDetailInfo(params)
    },

    onClickDetailTxt(row) {
      this.detailId = row.transaction_id
      this.showPayDetailModal()
    },

    onClickRefundTxt(row) {
      if ((row.original_refund_status && row.original_refund_status !== 1)) {
        this.detailId = row.transaction_id
        this.showPayRefundModal(row)
      }
    },

    showPayRefundModal(row) {
      this.$refs.paymentRefundModal.changModalStatus(true, row)
    },

    onClickFixedArrow() {
      this.showFilterContent = !this.showFilterContent
    },
    onClickReset() {
      this.search = {}
    },

    onClickDowmloadBtn() {
      if (!this.$commonFn.checkSubmitDateLimit(this.search.times, 31)) {
        this.$message.warning('The maximum date range  is limited to 31 days, please select again')
        return
      }
      if (!this.$commonFn.checkSubmitDateLimit(this.search.response_times, 31)) {
        this.$message.warning('The maximum date range  is limited to 31 days, please select again')
        return
      }
      const params = this.getParams()
      if (!params) {
        return
      }
      this.downloading = true
      PostPartnerMerchantDownloadPaymentFile(params).then(res => {
        const { data } = res
        if (!data.is_async) {
          const { list } = data
          this.handleXlsxData(list).then((downloadData) => {
            exportXlsx(downloadData, 'Pay_Trans_Details')
          })
        } else {
          this.$store.commit('app/SET_SHOW_DOWNLOAD_LIST', true)
        }
      }).finally(() => {
        setTimeout(() => {
          this.downloading = false
        }, 3000)
      })
    },

    handleXlsxData(data = []) {
      const rows = [[
        this.$t('customerService.transaction_id'),
        this.$t('merchantAccount.merchant_order_id'),
        this.$t('merchantAccount.transaction_amount'),
        this.$t('merchant.service_fee'),
        this.$t('merchantAccount.recipient_name'),
        this.$t('merchantAccount.recipient_mobile'),
        this.$t('merchantAccount.transaction_status'),
        this.$t('merchant.payment_channel'),
        // this.$t('merchantAccount.pay_trans_id'),
        this.$t('merchantAccount.create_time'),
        this.$t('merchantAccount.complete_time')
      ]]

      // const toDivideWithDot = this.$options.filters['toDivideWithDot']
      if (Array.isArray(data) && data.length > 0) {
        data.forEach((tr) => {
          rows.push([
            tr.transaction_id,
            tr.merchant_order_id,
            tr.amount,
            tr.fee,
            tr.name,
            tr.mobile,
            tr.status,
            tr.payment_channel,
            // tr.transaction_id,
            tr.create_time,
            tr.complete_time
          ])
        })
      }
      return Promise.resolve(rows)
    },
    onClickPaginator() {
      this.handleFilter(this.listQuery)
    }
  }
}
</script>

<style scoped>
.page-container{
  margin: 40px 57px 50px 32px;
}
.page-container .page-title{
  padding-bottom: 24px;
  border-bottom: 1px solid #D3D7DF;
}
.icon-warning-outline{
  position: relative;
  top: 2px;
  color:  #4B5567;
  font-size: 16px;
}
.pay-trans-details{
  .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Inter-Medium';
    color: #606266;
  }
  .filter-container{
    padding: 20px 0 0 20px;
  }
  .search-frame {
    width: 230px;
    margin-right: 5px;
  }
  .search-frame-order{
    width:200px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
  .picker{
    width: 230px
  }
  .mb-10{
    margin-bottom: 10px;
  }
  .detailTxt{
    font-size: 12px;
    color: #3579FF;
    text-decoration: underline;
     cursor: pointer;
  }
  .total-container{
    display: flex;
    border: 1px solid #D3D7DF;
    margin-bottom: 32px;
    .total-item{
      padding: 10px 0;
      flex: 1;
      text-align: center;
      border-right: 1px solid #D3D7DF;
      font-weight: 400;
      font-size: 14px;
      color: #4B5567;
    }
    .total-item:not(:last-child){
      border-right: 1px solid #D3D7DF;
    }
  }
}
.status-wrap {
  display: inline-block;
  position:relative;
  .status-tip-wrap {
    position:absolute;
    top:40%;
    transform:translateY(-50%);
    right:-20px;
  }
}

.wayBill_item {
  padding: 10px 20px !important;
}
.is-disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
.is-disabled:hover {
  color: #98A1B4;
}
</style>
